import StatusPill from '../../../common/components/status-pill/status-pill';
import { FINDING_RESULT_LABEL, FINDING_RESULT_TONE } from '../../../core/constants/domain';

import '../styles/criteria-list.css';

export default function CriteriaList({ criteria, findings }) {
    const byIndex = new Map((findings ?? []).map((finding) => [finding.index, finding]));
    return (
        <ol className="criteria-list">
            {criteria.map((criterion, index) => {
                const finding = byIndex.get(index);
                return (
                    <li key={criterion} className="criteria-list__item">
                        <span className="criteria-list__index" aria-hidden="true">{index + 1}</span>
                        <div className="criteria-list__body">
                            <p className="criteria-list__text">{criterion}</p>
                            {finding && (
                                <p className="criteria-list__finding">
                                    <StatusPill tone={FINDING_RESULT_TONE[finding.result]}>
                                        {FINDING_RESULT_LABEL[finding.result]}
                                    </StatusPill>
                                    {finding.note && <span className="criteria-list__note">{finding.note}</span>}
                                </p>
                            )}
                        </div>
                    </li>
                );
            })}
        </ol>
    );
}
